import React from 'react';
import './line.sass';

export const Line = () => {
    return <div className = "Line_buttom" />
}